import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import redirect from './redirect/redirect.js'

export default contract({
  redirect: array([
    redirect
  ])
})
